export { default as OrderFinishedDeliveryPage } from "./View";